<template>
  <gj-select
      ref="treeSelect"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="mineStatus"
      :multiple="showCheckbox"
      :collapse-tags="showCheckbox"
      type="tree-select"
      :filterable="false"
      :width="width"
      @change="selectChange">
    <el-option :value="mineStatusValue">
      <div @click.stop.prevent>
        <div class="gj-select-tree__search-input" :class="{'noValid':noValid}">
          <gj-input
              ref="searchInput"
              v-model="searchText"
              placeholder="搜索"
              underline
              multiCheckSearch
              width="100%"
          ></gj-input>
        </div>
        <el-tree
          ref="tree"
          v-bind="$attrs"
          :show-checkbox="showCheckbox"
          :data="data"
          :node-key="treeKey"
          highlight-current
          :props="treeProps"
          :filter-node-method="filterTree"
          style="overflow: auto;margin-right: 2px;"
          :style="{'width': fixedWidth,'maxHeight':treeMaxHeight}"
          @hook:mounted="treeMounted"
          @check-change="checkChange"
          @node-click="nodeClick"
        >
          <template v-slot:default="{node, data}" v-if="$scopedSlots.default">
            <slot :node="node" :data="data"></slot>
          </template>
        </el-tree>
      </div>
    </el-option>
  </gj-select>
</template>

<script>
  import {doNothingMixIn} from "../../minxins";
  import {isMeaningful, isMeaningless} from "../../utils/common";

  export default {
    name: 'gj-tree-select',
    mixins: [doNothingMixIn],
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      treeMinHeight:{
        type:String,
        default: '150px'
      },
      noValid:{
        type: Boolean,
        default: false,
      },
      value: {
        required: false
      },
      treeKey: {
        type: String,
        default: 'id',
      },
      width: {
        type: String,
        default: '165px'
      },
      treeProps: {
        type: Object,
        default: () => {
          return {
            label: 'label',
            children: 'children',
            disabled: 'disabled',
            isLeaf: 'isLeaf'
          };
        }
      },
      showCheckbox: {
        type: Boolean,
        default: false,
      },
      expandOnClickNode: {
        type: Boolean,
        default: false
      },
      selectAllNode: {
        type: Boolean,
        default: false
      },
      data: {
        type: Array,
        default: () => []
      },
      fixedWidth: { // tree部分宽度
        type: String
      }
    },
    data() {
      return {
        searchText: '',
        mineStatus: null,
        mineStatusValue: [],
        initNode: null,
        currentValue: this.value,
        currentData:{},
        treeMaxHeight:'300px'
      };
    },
    mounted() {
      //元素的下边界和父元素上边界的距离
      let bottom = this.$refs.treeSelect.$el.getBoundingClientRect().bottom;
      //window内高度
      let innerHeight = window.innerHeight;
      //输入框底边，距离window内底边的距离
      let height = innerHeight - bottom;
      //若小于400（tree和上方搜索框等，默认总高度为400左右）
      if (height < 400) {
        //设置tree最大高度，最少为150px
        this.treeMaxHeight = (height - 100) > 150 ? (height - 100 + 'px') : this.treeMinHeight;
      }
    },
    watch: {
      data() {
        this.$nextTick(_ => {
          this.setLabelVal();
        })
      },
      searchText(val) {
        this.$refs.tree.filter(val);
      },
      value: {
        handler: function(value, oldValue) {
          if (value !== oldValue) {
            if (this.$refs.tree && this.showCheckbox) {
              this.$refs.tree.setCheckedKeys(value || []);
            }
            this.currentValue = value;
          }
        },
      },
      currentValue (value, oldValue) {
        if (value !== oldValue) {
          this.$emit('input', value)
        }
      },
      treeValue: {
        handler: function({value, data}) {
          if (isMeaningful(value) && (!(value instanceof Array) || value.length > 0)) {
            const vm = this;
            this.$nextTick(() => {
              const node = vm.$refs.tree.getNode(value);
              if (node) {
                this.initNode = node;
                this.mineStatusValue = node.data;
                this.mineStatus = node.data[this.treeProps.label];
                this.currentValue = node.data[this.treeKey] || [];
                node.isCurrent = true;
              }
            });
          }
          if (isMeaningless(value)) {
            this.mineStatus = null;
            this.mineStatusValue = [];
          }
        },
        immediate: true
      }
    },
    computed: {
      treeValue() {
        return {
          value: this.currentValue,
          data: this.data
        };
      }
    },
    methods: {
      treeMounted() {
        if (this.showCheckbox) {
          this.$refs.tree.setCheckedKeys(this.currentValue || []);
        } else {
          this.$refs.tree.setChecked(this.currentValue || '');
        }
      },
      selectChange(e) {
        const arrNew = [];
        const dataLength = this.mineStatusValue.length;
        for (let i = 0; i < dataLength ;i++) {
          for (let j = 0; j < e.length; j++) {
            if (e[j] === this.mineStatusValue[i][this.treeProps.label]) {
              arrNew.push(this.mineStatusValue[i]);
            }
          }
        }
        this.$refs.tree.setCheckedNodes(arrNew); //设置勾选的值
        const data = arrNew.map(item => item[this.treeKey]);
        if (!this.showCheckbox && data.length === 0) {
          // 单选且无选择值
          this.currentValue = ''
        } else {
          this.currentValue = data
        }
      },
      setLabelVal() {
        let res;
        if (this.selectAllNode) {
          res = this.$refs.tree.getCheckedNodes(false, false);
        } else {
          res = this.$refs.tree.getCheckedNodes(true, true); // 这里两个true，1. 是否只是叶子节点 2. 是否包含半选节点（就是使得选择的时候不包含父节点）
        }
        let arrLabel = [];
        let arr = [];
        res.forEach(item => {
          arrLabel.push(item[this.treeProps.label]);
          arr.push(item);
        });
        this.mineStatusValue = arr;
        this.mineStatus = arrLabel.length ? arrLabel : null;
        return res
      },
      checkChange() {
        let res =  this.setLabelVal();
        this.currentValue = res.map(item => item[this.treeKey])
      },
      nodeClick(data, node, el) {
        if (this.expandOnClickNode && !node.isLeaf) {
          return;
        }
        if (!this.showCheckbox) {
          this.mineStatusValue = data;
          this.mineStatus = data[this.treeProps.label];
          node.expanded = false;
          if (this.initNode !== node && this.initNode) {
            this.initNode.isCurrent = false;
          }
          this.$refs.treeSelect.$refs.select.visible = false;
          this.currentValue = data[this.treeKey]
          this.currentData=data
        }
      },
      filterTree(value, data) {
        if (!value) return true;
        return data[this.treeProps.label].indexOf(value) !== -1;
      },
      visibleChange(visible) {
        this.$nextTick(() => {
          // this.$refs.searchInput.$refs.gjInput.$refs.input.focus();
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  /deep/ .el-tree-node__label {
    font-size: 12px;
  }
  .gj-select-tree__search-input {
    padding: 2px 8px 8px 8px;
  }
  .noValid{
    /deep/.el-input__validateIcon {
      display: none;
    }
  }
  /deep/ .el-tag:first-child .el-select__tags-text {
    max-width: 64px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  /deep/ .el-tag.el-tag--info .el-tag__close {
    display: none;
  }
  /deep/ .el-tree-node {
    overflow: hidden;
  }
</style>
